import { DTOFigmaComponentGroupListResponse } from "../../../dto";
import { RequestExecutor } from "../../../transport/request-executor";

export class FigmaComponentGroupsEndpoint {
  constructor(private readonly requestExecutor: RequestExecutor) {}

  async list(dsId: string, vId: string) {
    return this.requestExecutor.json(
      `/design-systems/${dsId}/versions/${vId}/component-groups`,
      DTOFigmaComponentGroupListResponse
    );
  }
}
